var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_443_2063)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 81.67C68.0302 81.67 81.835 67.8652 81.835 50.835C81.835 33.8048 68.0302 20 51 20C33.9699 20 20.165 33.8048 20.165 50.835C20.165 67.8652 33.9699 81.67 51 81.67ZM46.3748 66.2247C46.3748 63.5513 48.4068 61.6273 50.9723 61.6273C53.5933 61.6273 55.6253 63.5513 55.6253 66.2247C55.6253 68.8981 53.5933 70.8777 50.9723 70.8777C48.4068 70.8777 46.3748 68.8981 46.3748 66.2247ZM48.4469 32.334C48.2389 32.3342 48.033 32.3765 47.8418 32.4584C47.6505 32.5403 47.4778 32.66 47.334 32.8104C47.1903 32.9608 47.0784 33.1387 47.0053 33.3335C46.9321 33.5282 46.8991 33.7357 46.9082 33.9436L47.8518 55.5281C47.8693 55.9251 48.0394 56.3 48.3267 56.5747C48.6139 56.8493 48.9961 57.0024 49.3935 57.002H52.6096C53.007 57.0024 53.3892 56.8493 53.6765 56.5747C53.9638 56.3 54.1339 55.9251 54.1514 55.5281L55.0918 33.9436C55.101 33.7355 55.0679 33.5277 54.9945 33.3327C54.9212 33.1378 54.8091 32.9597 54.665 32.8093C54.5209 32.6589 54.3478 32.5392 54.1562 32.4575C53.9646 32.3758 53.7584 32.3338 53.5501 32.334H48.4469Z",
    fill: "#FF857E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_443_2063",
    x: 0.165039,
    y: 0,
    width: 101.67,
    height: 101.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_443_2063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_443_2063",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6eae2efb804f64b82e0a30849bc06ff4.svg";
export { ForwardRef as ReactComponent };